import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';
import { convertFromWei } from 'modules/api/utils';
import { IAccountPool } from 'modules/pool/types';

export async function getAccountPool(
  client: PublicClient,
  {
    poolAddress,
    accountAddress,
  }: { poolAddress: Address; accountAddress: Address },
): Promise<IAccountPool | null> {
  const poolContract = getDelegateStakingPoolContract(client, poolAddress);

  const stakedAmountWei = await poolContract.read.currentStake([
    accountAddress,
  ]);

  return {
    address: poolAddress,
    stakedAmount: convertFromWei(stakedAmountWei),
  };
}
